import React from "react";
import pic1 from "../assets/images/pic1.webp";
import pic2 from "../assets/images/pic2.webp";
import pic3 from "../assets/images/pic3.webp";
import pic4 from "../assets/images/pic4.webp";
import pic5 from "../assets/images/pic5.webp";
import pic6 from "../assets/images/pic6.webp";
import pic7 from "../assets/images/pic7.webp";
import pic8 from "../assets/images/pic8.webp";

const Bentogrid = () => {
  return (
    <article className="h-full w-full bg-slate-300 p-5">
      <div className="flex justify-center items-center gap-5">
        <div className="bg-orange-100 rounded-md h-96 w-72 p-10 mb-14">
          <pre className="font-bold text-4xl">
            Create and<br></br>schedule<br></br>content<br></br>
            <span className="text-purple-500">
              <i>quicker.</i>
            </span>
          </pre>
          <img className="object-cover mt-5 " src={pic4} alt="pic2" />
        </div>
        <div className="grid gap-10">
          <div className=" w-96 rounded-md p-10 bg-purple-500">
            <h1 className=" text-4xl font-bold text-center text-white">
              Social media <span className="text-yellow-600">10x</span>
            </h1>
            <h1 className="text-4xl font-bold text-center text-white">
              <i>Faster</i> with AI
            </h1>
            <img
              className="w-80 h-fit object-cover mx-auto"
              src={pic5}
              alt="pic5"
            />
            <h6 className="text-center text-gray-400">
              Over 4,000 5-star reviews.
            </h6>
          </div>
          <div className="w-96 flex justify-between items-center rounded-md space-x-5">
            <div className="h-44 w-72 bg-white px-5 py-2 rounded-md">
              <img className=" object-cover" src={pic7} alt="pic7" />
              <pre className="font-semibold text-xl">
                Manage<br></br>
                multiple<br></br>
                accounts and <br></br>
                platforms.<br></br>
              </pre>
            </div>
            <div className="h-44 w-72 bg-amber-300 px-5 py-2 rounded-md overflow-hidden">
              <pre className="font-semibold text-xl">
                Maintain a<br></br>
                consistent<br></br>
                posting<br></br>
                schedule.<br></br>
              </pre>
              <img className="h-18 object-cover" src={pic3} alt="pic3" />
            </div>
          </div>
        </div>
        <aside className=" bg-purple-100 rounded-md p-5 w-72 overflow-hidden">
          <h1 className="font-bold text-4xl text-slate-950">Schedule to</h1>
          <h1 className="font-bold text-4xl text-slate-950">Social Media.</h1>
          <div className="mt-2">
            <img
              src={pic8}
              className="object-cover w-80  rounded-md"
              alt="pic8"
            />
          </div>
          <pre className="px-5 mt-4 text-gray-700 font-semibold ">
            Optimize post timings<br></br>
            to publish content at<br></br>
            the perfect time for<br></br>
            your audience.
          </pre>
        </aside>
      </div>
      <div className="flex justify-between">
        <div className="grid bg-amber-300 w-72 ml-40 mb-10 p-5 rounded-md gap-5">
          <p className="text-4xl font-semibold text-wrap">
            Write your<br></br>content<br></br>using AI.
          </p>
          <img
            className="max-h-56 object-cover mx-auto"
            src={pic1}
            alt="pic1"
          ></img>
        </div>
        <div className="flex justify-between items-center mr-40 mb-28 space-x-16">
          <div className="bg-white h-60 w-60 p-5 rounded-md">
            <div className="p-2 grid justify-center items-center">
              <h1 className="text-6xl font-semibold">&#62;56%</h1>
              <h1 className="text-xs ml-2">faster audience growth.</h1>
            </div>
            <div className="p-5">
              <img
                className="h-14 w-60 object-cover"
                src={pic2}
                alt="pic2"
              ></img>
            </div>
          </div>
          <div className="flex justify-center items-center bg-purple-400 w-96 h-60 rounded-md">
            <div className="">
              <img className="h-40 w-52" src={pic6} alt="pic6"></img>
            </div>
            <div>
              <p className="text-white font-semibold text-2xl">
                Grow followers<br></br>with non-stop<br></br>content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default Bentogrid;
